module.exports = __webpack_public_path__ + "img/dropping keystones.00691ca0.png";